import { Injectable } from '@angular/core';
import { AppState } from '@get/store/configs/reducers';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GeneratedSocieteProfilService } from './societe-profil-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteProfilService extends GeneratedSocieteProfilService {
  constructor(store$: Store<AppState>, actions$: Actions) {
    super(store$, actions$);
  }
}
